import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40afa10d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-table" }
const _hoisted_2 = { class: "row-table-" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Visualizar", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "close" }
const _hoisted_8 = { class: "imagesSelected" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-primary" }, null, -1))
const _hoisted_10 = {
  key: 7,
  class: "d-flex gap-1"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "me-2"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "text-h6"
}
const _hoisted_15 = {
  key: 1,
  class: "me-2"
}
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "text-center textEmpty" }
const _hoisted_18 = {
  key: 1,
  class: "d-flex align-center pagination"
}
const _hoisted_19 = {
  key: 0,
  class: "w-100"
}

import { IHeadersTable } from '@/types';
import { withDefaults, ref, watch, onMounted, computed } from 'vue';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import { VueGoodTable } from 'vue-good-table-next';
import * as comps from '@/components/atoms';
import { MoleculeFilters, MoleculePagination } from '@/components/molecules';
import { AtomInput, AtomSelect, LoaderIcon } from '../atoms';
import { getDisplayStatus, getStatusClass } from '@/utils/statusUtils';
import { getPriorityClass } from '@/core/enum/priority';
import AtomImageUpload from '../atoms/AtomImageUpload.vue';
import CloseIcon from '../atoms/icons/CloseIcon.vue';
import AtomStar from '../atoms/AtomStar.vue';

interface IProps {
  headers: Array<IHeadersTable>;
  items: any[] & { enabled?: boolean }[];
  filters?: boolean;
  enableOptions?: boolean;
  disableSelectInfo?: boolean;
  selectOnCheckboxOnly?: boolean;
  textEmpty?: string;
  selectedClass?: string;
  indexSelect?: number;
  perPage?: number;
  page?: number;
  totalItems?: number;
  update?: boolean;
  pagination?: boolean;
  loading?: boolean;
  itemSelect?: any;
  hasOptions?: boolean;
  isFinanceira?: boolean;
  hasSelect?: boolean;
  localPagination?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTable',
  props: {
    headers: {},
    items: {},
    filters: { type: Boolean, default: false },
    enableOptions: { type: Boolean },
    disableSelectInfo: { type: Boolean },
    selectOnCheckboxOnly: { type: Boolean },
    textEmpty: { default: 'Sem informações para exibição' },
    selectedClass: { default: '' },
    indexSelect: {},
    perPage: { default: 10 },
    page: { default: 1 },
    totalItems: { default: 0 },
    update: { type: Boolean, default: false },
    pagination: { type: Boolean, default: true },
    loading: { type: Boolean },
    itemSelect: {},
    hasOptions: { type: Boolean, default: true },
    isFinanceira: { type: Boolean },
    hasSelect: { type: Boolean, default: false },
    localPagination: { type: Boolean, default: false }
  },
  emits: [
  'handleUpload',
  'rowClick',
  'changePerPage',
  'changePage',
  'updateRow',
  'searching',
  'handleSort',
  'blur',
  'viewPhoto',
],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const table = ref(null);
const lengthItems = computed(() => {
  return Math.ceil(props.totalItems / perPageTable.value);
});
const search = ref<string>('');
const props = __props;

const updateValues = ref<any>({});
const page = ref(1);
const perPageTable = ref(10);

const computedItems = computed(() => {
  if (props.localPagination) {
    return props.items.slice(perPageTable.value * ((page.value - 1)), (perPageTable.value * page.value));
  }

  return props.items;
});

onMounted(() => {
  page.value = props.page;
  perPageTable.value = props.perPage;

  if (props.itemSelect) {
    props.headers
      .filter((f) => !!f.update)
      .map((x) => {
        updateValues.value[String(x.update)] = props.itemSelect[String(x.update)];
      });
  }
});
watch(
  () => props.totalItems,
  () => {
    const totalPages = Math.ceil(props.totalItems / props.perPage);
    if (page.value > totalPages) {
      page.value = 1;
    }
  }
)
watch(
  () => page.value,
  () => {
    emit('changePage', page.value, perPageTable.value);
  }
);

watch(
  () => perPageTable.value,
  () => {
    emit('changePage', page.value, perPageTable.value);
  }
);
watch(
  () => props.page,
  () => {
    page.value = props.page;
  }
);
watch(
  () => perPageTable.value,
  (n, o) => {
    emit('changePerPage', perPageTable.value);
    if (n > o) page.value = 1;
  }
);
watch(
  () => props.perPage,
  () => {
    perPageTable.value = props.perPage;
  }
);
watch(
  () => updateValues.value,
  () => {
    emit('updateRow', updateValues.value);
  },
  { deep: true }
);

watch(
  () => search.value,
  () => {
    emit('searching', search.value);
  }
);

function onSortChange(params) {
  emit('handleSort', {
    type: params[0].type,
    field: params[0].field,
  });
}

watch(
  () => props.itemSelect,
  () => {
    if (props.itemSelect) {
      updateValues.value = {};

      const data: any = {};

      props.headers
        .filter((f) => !!f.update)
        .map((x) => {
          data[String(x.update)] = props.itemSelect[String(x.update)];
        });
      updateValues.value = data;
    }
  }
);

function handleBlur(event) {
  emit('blur', event);
}

function rowStyleClassFn(row) {
  const archived = row.archived == 1 ? 'inactive' : 'active';

  let clss = ` ${row.archived != undefined ? archived : ''} row-table ${props.selectedClass
    } ${props.indexSelect && row.id == props.indexSelect ? 'selected-row-sp' : ''} ${props.indexSelect && row.id == props.indexSelect && props.isFinanceira ? 'background-orange' : ''
    }`;
  return clss;
}

function validLine(row) {
  return props.indexSelect && row.id == props.indexSelect;
}
function handleUpload() {
  emit('handleUpload');
}
function onRowClick(params) {
  emit('rowClick', params);
}
function selectionChanged(params) {
  console.log('selected row', params);
}

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_AtomInputMoney = _resolveComponent("AtomInputMoney")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.filters)
      ? (_openBlock(), _createBlock(_unref(MoleculeFilters), {
          key: 0,
          modelValue: search.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          "has-search": "",
          onHandleUpload: handleUpload,
          onHandleBlur: handleBlur,
          "has-options": props.hasOptions
        }, {
          areaFilter: _withCtx(() => [
            _renderSlot(_ctx.$slots, "areaFilter")
          ]),
          _: 3
        }, 8, ["modelValue", "has-options"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(VueGoodTable), {
      mode: "remote",
      id: "vg-table",
      isLoading: props.loading,
      ref_key: "table",
      ref: table,
      onSortChange: onSortChange,
      "select-options": {
        enabled: _ctx.enableOptions,
        selectOnCheckboxOnly: _ctx.selectOnCheckboxOnly,
        disableSelectInfo: _ctx.disableSelectInfo,
      },
      onOnSelectedRowsChange: selectionChanged,
      styleClass: `vgt-table ${props.hasSelect ? 'cursor' : ''}`,
      "row-style-class": rowStyleClassFn,
      onRowClick: onRowClick,
      columns: _ctx.headers,
      rows: computedItems.value,
      pagination: _ctx.pagination
    }, _createSlots({
      loadingContent: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(LoaderIcon)), { class: "ma-auto w-100" }))
      ]),
      "table-row": _withCtx((props) => [
        _createElementVNode("div", _hoisted_2, [
          (props.column.field == 'qrcode')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "qrcode", { props: props })
              ]))
            : _createCommentVNode("", true),
          (props.column.field == 'pictures')
            ? (_openBlock(), _createBlock(_component_v_dialog, {
                key: 1,
                "max-width": "900",
                "min-height": "500",
                opacity: "0.6"
              }, {
                activator: _withCtx(({ props: activatorProps }) => [
                  _createElementVNode("span", _mergeProps({
                    class: "visualizar",
                    onClick: _withModifiers(($event: any) => (_ctx.$emit('viewPhoto', props.row)), ["stop"])
                  }, activatorProps), _hoisted_6, 16, _hoisted_4)
                ]),
                default: _withCtx(({ isActive }) => [
                  _createVNode(_component_v_card, {
                    "min-height": "500",
                    color: "#FAFAFA"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("p", null, "Fotos - " + _toDisplayString(props.row.name), 1),
                        _createVNode(CloseIcon, {
                          onClick: ($event: any) => (isActive.value = false)
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.thumbnails, (item, index) => {
                          return (_openBlock(), _createBlock(AtomImageUpload, {
                            "image-file": item,
                            key: index,
                            disabled: true,
                            index: index
                          }, null, 8, ["image-file", "index"]))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (props.column.type == 'showColor')
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(["d-flex gap-1", { 'disabled': !(props.row.enabled ?? true) }])
              }, [
                _createElementVNode("div", {
                  style: _normalizeStyle({
                width: '16px',
                height: '16px',
                backgroundColor: props.formattedRow[props.column.field] ?? undefined,
                borderRadius: '50%',
              })
                }, null, 4)
              ], 2))
            : (props.column.type == 'icon')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: _normalizeClass(["d-flex gap-1", { 'disabled': !(props.row.enabled ?? true) }])
                }, [
                  (_openBlock(), _createBlock(_component_v_icon, {
                    key: props.formattedRow[props.column.field]
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.formattedRow[props.column.field]), 1)
                    ]),
                    _: 2
                  }, 1024)),
                  _hoisted_9
                ], 2))
              : (props.column.type == 'priority')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    class: _normalizeClass(["d-flex gap-1", { 'disabled': !(props.row.enabled ?? true) }])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(_unref(getPriorityClass)(props.formattedRow[props.column.field]))
                    }, _toDisplayString(props.formattedRow[props.column.field]), 3)
                  ], 2))
                : (props.column.type == 'status')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      class: _normalizeClass(["d-flex gap-1", { 'disabled': !(props.row.enabled ?? true) }])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["tag status-tag", _unref(getStatusClass)(props.formattedRow[props.column.field])])
                      }, _toDisplayString(_unref(getDisplayStatus)(props.formattedRow[props.column.field])), 3)
                    ], 2))
                  : (props.column.field == 'actions')
                    ? _renderSlot(_ctx.$slots, "actions", _mergeProps({ key: 6 }, _ctx.$attrs, { props: props }))
                    : (typeof props.formattedRow[props.column.field] === 'boolean')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (props.formattedRow[props.column.field])
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                color: "#FF5C00",
                                size: "24"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-checkbox-marked")
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_icon, {
                                key: 1,
                                size: "24"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-checkbox-blank-outline")
                                ]),
                                _: 1
                              }))
                        ]))
                      : (props.column.field == 'minimalRating' || props.column.field == 'rating')
                        ? (_openBlock(), _createBlock(AtomStar, {
                            key: 8,
                            size: "24px",
                            rating: props.column.field == 'minimalRating' ? props.row.minimalRating : props.row.rating
                          }, null, 8, ["rating"]))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 9,
                            class: _normalizeClass({ 'disabled': !(props.row.enabled ?? true) })
                          }, [
                            (_ctx.update && !!props.column.mode && validLine(props.row))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  (props.column.mode == 'money')
                                    ? (_openBlock(), _createBlock(_component_AtomInputMoney, {
                                        key: 0,
                                        label: props.column.label,
                                        prependIcon: "",
                                        modelValue: updateValues.value[props.column.update],
                                        "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event)
                                      }, {
                                        prependIcon: _withCtx(() => [
                                          _createTextVNode(" R$ ")
                                        ]),
                                        _: 2
                                      }, 1032, ["label", "modelValue", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true),
                                  (props.column.mode == 'date')
                                    ? (_openBlock(), _createBlock(_unref(AtomInput), {
                                        key: 1,
                                        type: "date",
                                        modelValue: updateValues.value[props.column.update],
                                        "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                                        label: props.column.label
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                    : _createCommentVNode("", true),
                                  (props.column.mode == 'input')
                                    ? (_openBlock(), _createBlock(_unref(AtomInput), {
                                        key: 2,
                                        modelValue: updateValues.value[props.column.update],
                                        "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                                        label: props.column.label
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                    : _createCommentVNode("", true),
                                  (props.column.mode == 'select')
                                    ? (_openBlock(), _createBlock(_unref(AtomSelect), {
                                        key: 3,
                                        width: "154px",
                                        label: props.column.label,
                                        modelValue: updateValues.value[props.column.update],
                                        "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                                        options: props.column.options
                                      }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "options"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (props.column.extra && props.column.extra.avatar)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                        _createVNode(_component_v_avatar, {
                                          rounded: 8,
                                          color: "grey",
                                          size: "48"
                                        }, {
                                          default: _withCtx(() => [
                                            (props.row['avatar']?.includes('http'))
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  style: {"width":"100%","height":"100%"},
                                                  src: `${props.row['avatar'] ?? ''}`,
                                                  crossorigin: "anonymous",
                                                  alt: "avatar"
                                                }, null, 8, _hoisted_13))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString((props.row['avatar'] ?? '').toUpperCase()), 1))
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createTextVNode(" " + _toDisplayString(props.formattedRow[props.column.field]), 1)
                                      ]))
                                    : (props.column.extra && props.column.extra.icon)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                          (props.row.icon)
                                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(comps[props.row.icon]), { key: 0 }))
                                            : _createCommentVNode("", true),
                                          _createTextVNode(" " + _toDisplayString(props.formattedRow[props.column.field]), 1)
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass({ 'overflow-text-table': props.column.maxLines })
                                          }, _toDisplayString(props.formattedRow[props.column.field]), 3),
                                          (props.column.maxLines)
                                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                key: 0,
                                                activator: "parent",
                                                location: "top"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(props.formattedRow[props.column.field]), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]))
                                ], 64))
                          ], 2)),
          (props.column.extra && !props.column.extra.avatar && !props.column.extra.icon)
            ? (_openBlock(), _createElementBlock("div", {
                key: 10,
                class: _normalizeClass(props.column.classExtra)
              }, _toDisplayString(props.row[props.column.fieldExtra]), 3))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      (!!_ctx.textEmpty)
        ? {
            name: "emptystate",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.textEmpty), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["isLoading", "select-options", "styleClass", "columns", "rows", "pagination"]),
    (props.pagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          (props.totalItems != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_unref(MoleculePagination), {
                  class: "pagination-component",
                  modelValue: page.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((page).value = $event)),
                  numberOfPages: lengthItems.value,
                  "options-per-page": [2, 5, 10, 20],
                  "total-items": props.totalItems,
                  perPage: perPageTable.value,
                  onChangePerPage: _cache[2] || (_cache[2] = ($event: any) => (perPageTable.value = $event))
                }, null, 8, ["modelValue", "numberOfPages", "total-items", "perPage"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})